/**
 * Maps product slugs to real product photography URLs.
 * Any slug NOT listed here falls back to the generated ProductVial SVG graphic.
 * To add more real photos later, just add another "slug": "url" entry.
 */
export const PRODUCT_IMAGES = {
  retatrutide: "/products/retatrutide.png",
  tirzepatide: "/products/tirzepatide.png",
  semaglutide: "/products/semaglutide-v2.png",
  "bpc-157": "/products/bpc-157-v3.png",
  wolverine: "/products/wolverine.png",
  "ghk-cu": "/products/ghk-cu.png",
  tesamorelin: "/products/tesamorelin-v2.png",
  "cjc-1295-ipamorelin": "/products/cjc-1295-ipamorelin-v3.png",
  "mots-c": "/products/mots-c-v2.png",
  "tb-500": "/products/tb-500-v2.png",
  "nad-plus": "/products/nad-plus.png",
  glow: "/products/glow.png",
};

export function getProductImage(slug, product) {
  return product?.images?.[0] || PRODUCT_IMAGES[slug] || null;
}
